import { render, staticRenderFns } from "./AddBodyType.vue?vue&type=template&id=18a5fc0a&scoped=true"
import script from "./AddBodyType.vue?vue&type=script&lang=js"
export * from "./AddBodyType.vue?vue&type=script&lang=js"
import style0 from "./AddBodyType.vue?vue&type=style&index=0&id=18a5fc0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a5fc0a",
  null
  
)

export default component.exports